import axios from 'axios'
import moment from 'moment'
import router from '../../router/router'

const state = {
  form_data: {
    company_name: null,
    name: null,
    phone: null,
    email: null,
    machines: null,
    contact_time: null
  },
  invalidLeadFields: false
}

const mutations = {
  updateFormData (state, values) {
    for (let key in values) {
      state.form_data[key] = values[key]
    }
  },
  updateInvalidFields (state, values) {
    state.invalidLeadFields = values
  }
}

const getters = {}

const actions = {
  submitForm ({state, commit, dispatch}) {
    dispatch('validateForm')
    if (state.invalidLeadFields) return false

    const formData = JSON.parse(JSON.stringify(state.form_data))

    formData.contact_time = moment(state.form_data.contact_time).format("YYYY-MM-DD HH:mm:ss")

    axios.post('/leads', formData)
      .then(() => {
        router.replace({name: 'orders.success'})
      })
      .catch((error) => {
        console.log(error)
        // TODO we need some notifications system
      })
  },

  validateForm ({state, commit}) {
    let invalidLeadFields = {}
    commit('updateInvalidFields', false)

    const phoneno = /^\d{11}$/

    if (!state.form_data.company_name) invalidLeadFields.company_name = true
    if (!state.form_data.name) invalidLeadFields.name = true
    if (!state.form_data.phone || (state.form_data.phone && state.form_data.phone.length < 11)) {
      invalidLeadFields.contact_phone = true
    } else if (state.form_data.phone && !state.form_data.phone.match(phoneno)) {
      invalidLeadFields.contact_phone = true
    }
    if (!state.form_data.email) invalidLeadFields.email = true
    if (!state.form_data.contact_time) invalidLeadFields.contact_time = true

    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let invalidEmails = ['@neopost.co.uk', '@dataquestuk.com', '@osjersey.co.uk', '@altech-solutions.com', '@altodigital.com', '@nslmailing.co.uk', '@kanemailing.com', '@themailingroom.com', '@compareall.ltd.uk', '@apogeecorp.com', '@digitalsolutionsltd.com', '@ommdigital.co.uk', '@gemuk.co.uk', '@twofold.co.uk', '@frama.co.uk', '@gemuk.co.uk', '@nationwidefrankingsense.co.uk', '@kanemailing.com', '@ncs-ltd.com', '@fpmailing.co.uk', '@ecofranking.co.uk', '@mailcoms.co.uk', '@fpmailingec.co.uk', '@fpwestend.co.uk', '@frankedmail.co.uk', '@officefox.org.uk', '@linkmailingsystems.com', '@mymailingroom.com', '@frankingmachineexpers.co.uk', '@fp-midshires.co.uk', '@pb.com', '@fpmailinglandc.co.uk', '@fpmailingcity.co.uk', '@greenfranking.co.uk', '@stamps.com', '@digitalpostsolutions.com', '@documentdatagroup.com', '@totalpost.com', '@ntdltd.com', '@franking.com', '@europeanpostalsystems.co.uk', '@mailserveltd.co.uk', '@northernservices.co.uk', '@nslmailing.co.uk', '@ims-franking.co.uk', '@pro-copy.co.uk', '@ashcroftmailing.co.uk']
    if (!re.test(state.form_data.email)) {
      invalidLeadFields.email = true
    } else {
      let parts = state.form_data.email.split('@')
      let provider = ('@' + parts[1]).toLowerCase().trim()
      if (_.indexOf(invalidEmails, provider) > -1) {
        invalidLeadFields.email = true
      }
    }

    invalidLeadFields = Object.keys(invalidLeadFields).length > 0 ? invalidLeadFields : false
    if (invalidLeadFields) commit('updateInvalidFields', invalidLeadFields)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/LeadForm.js